// French dictionary: the source of every other language. One file per area
// of the product; `Messages` is the shape every language must match.

import { common } from "./common";
import { auth } from "./auth";
import { shell } from "./shell";
import { dashboard } from "./dashboard";
import { leads } from "./leads";
import { reports } from "./reports";
import { settings } from "./settings";
import { api } from "./api";
import { emails } from "./emails";

export const fr = { common, auth, shell, dashboard, leads, reports, settings, api, emails };

export type Messages = typeof fr;
